<template>
  <CContainer class="datatable-container">
    <Loader :is-processing="isLoading" />
    <CRow>
      <CCol md="12" class="text-center">
        <h1 class="mb-4">Locations (rooms)</h1>
      </CCol>
      <CCol md="5">
        <div id="room-form" class="rounded-panel px-4 py-2">
          <div class="d-flex justify-content-between align-items-center py-2">
            <span
              v-if="editableRoom && editableRoom.id"
              class="text-value-lg fw-light d-block rounded-panel-title"
              >Edit Room</span
            >
            <span
              v-else
              class="text-value-lg fw-light d-block rounded-panel-title"
            >
              Add Location/Room
              <HelpCenterButton classes="ms-2" content-key="rooms_title" />
            </span>
            <span
              class="d-flex align-items-center justify-content-center text-white rounded-circle bg-gradient-blue p-2"
              @click="toggleTab('addRooms')"
            >
              <i v-if="!tabs.addRooms" class="flaticon-double-chevron down" />
              <i v-else class="flaticon-double-chevron up" />
            </span>
          </div>

          <div v-show="tabs.addRooms">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <CFormInput
                    class="mb-1"
                    placeholder="Room name"
                    type="text"
                    :class="{
                      'is-invalid':
                        v$.form.name.$error || formReqResponse.errors['name']
                    }"
                    v-model="form.name"
                  />
                  <div
                    v-if="v$.form.$error && v$.form.name.required.$invalid"
                    class="invalid-feedback"
                  >
                    Room name is required
                  </div>
                  <div
                    v-if="formReqResponse.errors['name']"
                    class="invalid-feedback"
                  >
                    {{ formReqResponse.errors["name"][0] }}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <VSelect
                    class="mb-1"
                    :class="{
                      'is-invalid':
                        v$.form.trip_type.$error ||
                        formReqResponse.errors['trip_type']
                    }"
                    :reduce="(option) => option.value"
                    :clearable="false"
                    :options="roomTypes"
                    placeholder="Trip type"
                    :model-value="form.trip_type"
                    @update:model-value="(el) => (form.trip_type = el)"
                  />
                  <div
                    v-if="v$.form.$error && v$.form.trip_type.required.$invalid"
                    class="invalid-feedback"
                  >
                    Trip type is required
                  </div>
                  <div
                    v-if="formReqResponse.errors['trip_type']"
                    class="invalid-feedback"
                  >
                    {{ formReqResponse.errors["trip_type"][0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <VSelect
                    class="mb-1"
                    :class="{
                      'is-invalid':
                        v$.form.comment_type.$error ||
                        formReqResponse.errors['comment_type']
                    }"
                    :options="[
                      {
                        value: 'Mandatory',
                        label: 'Mandatory'
                      },
                      {
                        value: 'Optional',
                        label: 'Optional'
                      },
                      {
                        value: 'Hidden',
                        label: 'Hidden'
                      }
                    ]"
                    :reduce="(option) => option.value"
                    :clearable="false"
                    placeholder="Comment Type"
                    :model-value="form.comment_type"
                    @update:model-value="(el) => (form.comment_type = el)"
                  />
                  <div
                    v-if="
                      v$.form.$error && v$.form.comment_type.required.$invalid
                    "
                    class="invalid-feedback"
                  >
                    Comment type is required
                  </div>
                  <div
                    v-if="formReqResponse.errors['comment_type']"
                    class="invalid-feedback"
                  >
                    {{ formReqResponse.errors["comment_type"][0] }}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <VSelect
                    :options="[
                      {
                        value: '1',
                        label: 'Active'
                      },
                      {
                        value: '0',
                        label: 'Inactive'
                      }
                    ]"
                    :reduce="(option) => option.value"
                    :clearable="false"
                    placeholder="Status"
                    :model-value="form.status"
                    @update:model-value="(el) => (form.status = el)"
                  />
                  <div
                    v-if="v$.form.$error && v$.form.status.required.$invalid"
                    class="invalid-feedback"
                  >
                    This field is required
                  </div>
                  <div
                    v-if="formReqResponse.errors['status']"
                    class="invalid-feedback"
                  >
                    {{ formReqResponse.errors["status"][0] }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-inline">
                  <CCheckBox
                    label="Extended pass"
                    v-model="form.is_extended"
                    :checked="!!form.is_extended"
                    @update:model-value="clearExtendedPass()"
                    class="custom-checkbox"
                  >
                  </CCheckBox>
                </div>
                <div v-show="form.is_extended" class="form-group">
                  <CustomTimePicker
                    :show-seconds="true"
                    v-model="form.extended_pass_time"
                    format="HH:mm:ss"
                    picker-time-format="HH:mm:ss"
                    placeholder="End Time"
                    :class="[
                      {
                        'is-invalid': !!(
                          v$.form.extended_pass_time.$error ||
                          formReqResponse.errors['extended_pass_time']
                        )
                      },
                      'wider'
                    ]"
                  >
                    <template #footer>
                      <div
                        v-if="
                          v$.form.$error &&
                          v$.form.extended_pass_time.required.$invalid
                        "
                        class="invalid-feedback"
                      >
                        This field is required
                      </div>
                      <div
                        v-if="formReqResponse.errors['extended_pass_time']"
                        class="invalid-feedback"
                      >
                        {{ formReqResponse.errors["extended_pass_time"][0] }}
                      </div>
                    </template>
                  </CustomTimePicker>
                </div>
              </div>
            </div>

            <CAlert
              v-if="formReqResponse.message"
              class="mt-1"
              :color="formReqResponse.type"
              :show="!!formReqResponse.message"
            >
              {{ formReqResponse.message }}
            </CAlert>

            <div v-if="editableRoom && editableRoom.id" class="d-flex">
              <div @click="submit(false)">
                <CLoadingButton
                  :spinner="isFormLoading"
                  :loading="isFormLoading"
                  class="btn bg-gradient-blue text-white"
                >
                  Update
                </CLoadingButton>
              </div>
              <div class="ms-3" @click="cancelEdit()">
                <CButton class="btn-gradient-border">
                  <span class="btn px-4"
                    ><b class="text-graident-blue">Cancel</b></span
                  >
                </CButton>
              </div>
            </div>
            <div
              v-else
              class="d-flex justify-content-center align-items-center"
            >
              <div @click="submit(true)">
                <CLoadingButton
                  :spinner="isFormLoading"
                  :loading="isFormLoading"
                  class="btn bg-gradient-blue text-white"
                >
                  Add Location/Room
                </CLoadingButton>
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol md="7">
        <div class="rounded-panel px-4 py-2 mt-4 mt-md-0">
          <div class="d-flex justify-content-between align-items-center py-2">
            <span class="text-value-lg fw-light d-block rounded-panel-title"
              >Manage Admin favourite locations/rooms and people</span
            >
            <span
              class="d-flex align-items-center justify-content-center text-white rounded-circle bg-gradient-blue p-2"
              @click="toggleTab('favoriteRooms')"
            >
              <i
                v-if="!tabs.favoriteRooms"
                class="flaticon-double-chevron down"
              />
              <i v-else class="flaticon-double-chevron up" />
            </span>
          </div>
          <div v-show="tabs.favoriteRooms">
            <p class="text-value-xs fw-light">
              Use the “Edit” below to add icons to your rooms and drag and drop
              rooms into the order you like. Teachers will see these rooms and
              icons in the same order whenever they create a Teacher Pass.
            </p>

            <RoomsCarousel @favorites-updated="getRooms" />
          </div>
        </div>
      </CCol>
    </CRow>

    <CRow class="mt-4">
      <CCol md="5">
        <div class="rounded-panel px-4 py-2">
          <div class="d-flex justify-content-between align-items-center py-2">
            <span class="text-value-lg fw-light d-block rounded-panel-title">
              Import Locations/Rooms
              <HelpCenterButton classes="ms-2" content-key="rooms_import" />
            </span>
            <span
              class="d-flex align-items-center justify-content-center text-white rounded-circle bg-gradient-blue p-2"
              @click="toggleTab('importRooms')"
            >
              <i
                v-if="!tabs.importRooms"
                class="flaticon-double-chevron down"
              />
              <i v-else class="flaticon-double-chevron up" />
            </span>
          </div>
          <div v-show="tabs.importRooms">
            <p class="text-value-xs fw-light">
              Each room you import will need 2 pieces of required information.
              The third column is optional.
              <br />
              A room name (eg. Room 101). The "Trip Type" you want to use for
              passes to that location. "Trip Type" refers to how many adults are
              expected to interact on that pass. Its only function is to provide
              the pass (and teacher's dashboard) with the logically correct
              button options and to correctly color code an unexpected adult
              interaction on that pass.
              <br />

              <help-center-button
                content-key="rooms_import"
                custom="<a href='#' >Read more...</a>"
              />
            </p>
            <div class="form-group">
              <input
                id="rooms-import-input"
                ref="file"
                type="file"
                class="form-control"
              />
            </div>
            <div class="d-flex justify-content-center" @click="importRooms">
              <CLoadingButton
                :spinner="isImportLoading"
                :loading="isImportLoading"
                class="me-2 btn bg-gradient-blue text-white"
              >
                Import
              </CLoadingButton>
            </div>
            <CAlert
              v-if="importReqResponse.message"
              class="mt-4"
              :color="importReqResponse.type"
              :show="!!importReqResponse.message"
            >
              <div>
                <ul
                  v-if="
                    importReqResponse.errors && importReqResponse.errors.length
                  "
                  class="my-1 ps-0 text-start"
                >
                  <li
                    v-for="(error, key) in importReqResponse.errors"
                    :key="key"
                  >
                    {{ error[0] ? error[0] : "" }}
                  </li>
                </ul>
                <div v-else>
                  {{ importReqResponse.message }}
                </div>
              </div>
            </CAlert>
          </div>
        </div>
      </CCol>
    </CRow>

    <CCol md="12" class="bg-white mt-4">
      <div
        class="table-tabs-header mb-2 bg-white d-flex align-items-center justify-content-between"
      >
        <div
          v-for="(tab, index) in tableTabs"
          :key="index"
          class="flex-grow-1 flex-sm-grow-0"
        >
          <div
            class="table-tab"
            :class="{ active: tab.value === activeTableTab.value }"
          >
            {{ tab.label }}
          </div>
        </div>
        <div class="d-flex align-items-center">
          <CLink
            class="lh-normal text-accent-blue-light ms-2 ms-sm-0"
            download="rooms.csv"
            target="_blank"
            @click="exportRooms"
          >
            <i class="fi flaticon-download me-1" />
            <span class="d-none d-md-inline-block">Download CSV</span>
          </CLink>

          <div class="d-flex align-items-center search-field mb-0 ms-2 ms-md-4">
            <CInputGroup class="w-auto">
              <div class="input-group-prepend">
                <span class="input-group-text lh-normal"
                  ><div><i class="flaticon-magnifying-glass"></i></div
                ></span>
              </div>
              <CFormInput
                placeholder="Search"
                v-model="columnSearchKeys.globalQuery"
                @input="searchByQuery($event.target.value)"
              >
              </CFormInput>
            </CInputGroup>
          </div>
        </div>
      </div>
    </CCol>

    <CCol md="12" class="text-value-sm mt-2">
      <ParPageSelector :pagination="pagination" :action="setPerPage" />
    </CCol>

    <CCol md="12" class="mt-2 px-0">
      <DataTable
        :items="rooms"
        :fields="activeTableFields"
        :column-filter="true"
        :sorter="{ external: true }"
        :no-items-view="{
          noResults: 'No items available',
          noItems: 'No items available'
        }"
        @update:sorter-value="sortByColumn"
      >
        <template #admin_favorite="{ item }">
          <td
            v-if="user.role.name == 'admin'"
            class="text-center"
            :class="{ 'is-favorite': item.admin_favorite }"
          >
            <div v-if="item.status">
              <div v-if="favorites.length < 10">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-star-fill"
                  viewBox="0 0 16 16"
                  :style="user.role.name == 'admin' ? 'cursor:pointer' : ''"
                  @click="addAdminFav(item)"
                >
                  <path
                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                  />
                </svg>
              </div>
              <div v-else>
                <svg
                  v-if="item.admin_favorite"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-star-fill"
                  viewBox="0 0 16 16"
                  :style="user.role.name == 'admin' ? 'cursor:pointer' : ''"
                  @click="addAdminFav(item)"
                >
                  <path
                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                  />
                </svg>
                <svg
                  v-else
                  v-c-popover="{
                    header: 'Opps!',
                    content: `You are limited to a maximum of 10 favorites.`,
                    trigger: 'hover',
                    placement: 'right'
                  }"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-star-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
                  />
                </svg>
              </div>
            </div>
          </td>
          <td v-else>
            <svg
              v-c-popover="{
                header: 'Opps!',
                content: `Only admin can mark this as favorite.`,
                trigger: 'hover',
                placement: 'right'
              }"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-star-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
              />
            </svg>
          </td>
        </template>
        <template #name="{ item }">
          <td class="text-truncate fw-bold">
            {{ item.name }}
          </td>
        </template>

        <template #name-filter>
          <input
            v-model="columnSearchKeys.name.value"
            class="form-control form-control-sm my-2"
            @input="searchByQuery($event.target.value, 'column')"
          />
        </template>

        <template #comment_type="{ item }">
          <td>
            <span
              class="px-3 text-uppercase rounded py-1 text-white fw-bold d-block text-center w-full"
              :class="{
                'bg-red': item.comment_type == 'Hidden',
                'bg-green-success-status': item.comment_type == 'Mandatory',
                'bg-blue': item.comment_type == 'Optional'
              }"
              >{{ item.comment_type }}</span
            >
          </td>
        </template>

        <template #comment_type-filter>
          <input
            v-model="columnSearchKeys.comment.value"
            class="form-control form-control-sm my-2"
            @input="searchByQuery($event.target.value, 'column')"
          />
        </template>

        <template #trip_type="{ item }">
          <td class="text-truncate fw-bold">
            {{ item.trip_type }}
          </td>
        </template>

        <template #trip_type-filter>
          <input
            v-model="columnSearchKeys.trip.value"
            class="form-control form-control-sm my-2"
            @input="searchByQuery($event.target.value, 'column')"
          />
        </template>

        <template #status="{ item }">
          <td>
            <span
              class="px-3 py-1 text-uppercase rounded text-white d-block text-center w-full"
              :class="{
                'bg-light-green': item.status,
                'bg-gray': !item.status
              }"
              >{{ item.status ? "Active" : "Inactive" }}</span
            >
          </td>
        </template>

        <template #status-filter>
          <input
            class="form-control form-control-sm my-2"
            @input="matchStatus($event.target.value)"
          />
        </template>

        <template #extended_pass_time="{ item }">
          <td>
            <div class="d-flex align-items-center">
              <span class="fw-bold me-2">{{ item.extended_pass_time }}</span>
            </div>
          </td>
        </template>

        <template #extended_pass_time-filter>
          <input
            v-model="columnSearchKeys.extended_pass_time.value"
            class="form-control form-control-sm my-2"
            @input="searchByQuery($event.target.value, 'column')"
          />
        </template>

        <template #enable_appointment_passes="{ item }">
          <td>
            <div class="d-flex align-items-center">
              <span class="fw-bold me-2">No</span>
              <CFormSwitch
                class="modules-switch mx-1"
                shape="pill"
                :checked="Boolean(item.enable_appointment_passes)"
                @update:model-value="allowAPTRequestToRoom(item)"
              />
              <span class="fw-bold ms-2">Yes</span>
            </div>
          </td>
        </template>

        <template #enable_appointment_passes-filter>
          <input
            class="form-control form-control-sm my-2"
            @input="matchAPTRequests($event.target.value)"
          />
        </template>

        <template #actions="{ item }">
          <td>
            <button
              class="px-3 py-1 rounded bg-light-blue text-white d-flex align-items-center border-0"
              @click="editRoom(item)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-pencil"
                viewBox="0 0 16 16"
              >
                <path
                  d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                />
              </svg>
              <span class="ms-1 text-uppercase fw-bold">Edit</span>
            </button>
          </td>
        </template>
      </DataTable>

      <Pagination
        v-if="
          pagination &&
          pagination.pages &&
          pagination.pages > 1 &&
          !isLazyLoadingMode
        "
        class="cs-pagination mt-4"
        :dots="false"
        :double-arrows="true"
        :active-page="pagination.activePage"
        :pages="pagination.pages"
        size="lg"
        align="center"
        @update:active-page="setActivePage"
      >
        <template #last-button>
          <i class="flaticon-right-arrow-1" />
        </template>
        <template #first-button>
          <i class="flaticon-left-arrow-2" />
        </template>
        <template #previous-button>
          <i class="fi flaticon-left-arrow-1" />
        </template>
        <template #next-button>
          <i class="fi flaticon-chevron" />
        </template>
      </Pagination>
    </CCol>

    <!-- MODALS -->
  </CContainer>
</template>
<script>
import { mapGetters } from "vuex"
import Loader from "@/components/Loader"
import { required, requiredIf } from "vuelidate/lib/validators"
import HelpCenterButton from "../HelpCenterButton"
import RoomsCarousel from "../Forms/RoomsCarousel"
import ParPageSelector from "./../PerPageSelector.vue"
import useVuelidate from "@vuelidate/core"

export default {
  name: "RoomsDataTable",
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    RoomsCarousel,
    HelpCenterButton,
    Loader,
    ParPageSelector
  },
  data() {
    return {
      isLazyLoadingMode: false,
      isLoading: false,
      isFormLoading: false,
      isImportLoading: false,
      form: {
        name: "",
        trip_type: "",
        comment_type: null,
        status: "1",
        is_extended: false,
        extended_pass_time: "01:30:00"
      },
      defaultExtendedPassTime: "01:30:00",
      showReadMore: false,
      rooms_csv_file: null,
      pagination: {
        activePage: 1,
        total: 0,
        pages: 0,
        per_page: {
          label: "25",
          value: 25
        }
      },
      tabs: {
        addRooms: false,
        importRooms: false,
        favoriteRooms: true
      },
      importReqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      formReqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      tableTabs: [
        {
          label: "Locations (rooms)",
          value: "rooms"
        }
      ],
      activeTableTab: {
        value: "rooms",
        label: "Locations (rooms)"
      },
      filterParams: {
        sort_query: "asc",
        searchQuery: ""
      },
      fields: [
        {
          key: "admin_favorite",
          label: "Favorites",
          filter: false
        },
        {
          key: "name",
          label: "Room"
        },
        {
          key: "comment_type",
          _style: {
            color: "red"
          },
          label: "Comment"
        },
        {
          key: "trip_type",
          label: "Trip Type"
        },
        {
          key: "extended_pass_time",
          label: "Extended Pass Time",
          _style: "min-width:150px"
        },
        {
          key: "enable_appointment_passes",
          label: "Allow students APT Requests",
          requireLocationModule: true,
          _style: "min-width:220px"
        },
        {
          key: "status",
          label: "Status"
        },
        {
          key: "actions",
          label: "Actions",
          filter: false
        }
      ],
      columnSearchKeys: {
        globalQuery: "",
        name: {
          value: "",
          column: ["name"]
        },
        comment: {
          value: "",
          column: ["comment_type"]
        },
        trip: {
          value: "",
          column: ["trip_type"]
        },
        extended_pass_time: {
          value: "",
          column: ["extended_pass_time"]
        },
        enable_appointment_passes: {
          value: "",
          column: ["enable_appointment_passes"]
        },
        status: {
          value: "",
          column: ["status"]
        }
      },
      roomTypes: [
        {
          value: "Layover",
          label: "Layover"
        },
        {
          value: "One Way",
          label: "One Way"
        },
        {
          value: "Roundtrip",
          label: "Roundtrip"
        }
      ]
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      trip_type: {
        required
      },
      comment_type: {
        required
      },
      status: {
        required
      },
      extended_pass: {},
      extended_pass_time: {
        required: requiredIf((model) => model.extended_pass)
      }
    }
  },
  computed: {
    ...mapGetters({
      rooms: "rooms/rooms",
      editableRoom: "rooms/editableRoom",
      activeAppoinmentModuleOptions: "schools/activeAppoinmentModuleOptions",
      passesTimeSetting: "passes/passesTimeSettings",
      user: "authentication/user",
      fromFavorites: "favorites/fromFavorites"
    }),
    isActiveLocationModuleOption() {
      return (
        this.activeAppoinmentModuleOptions &&
        this.activeAppoinmentModuleOptions.location
      )
    },
    activeTableFields() {
      return !this.isActiveLocationModuleOption
        ? this.fields.filter((field) => !field.requireLocationModule)
        : this.fields
    },
    isValid() {
      return !this.v$.form.$invalid
    },
    favorites() {
      return this.fromFavorites.filter(
        (e) => e.section == "destination" && e.global == true
      )
    }
  },
  watch: {
    editableRoom: function (room) {
      this.setFormByRoomRecord(room)
    }
  },
  unmounted() {
    this.cancelEdit()
  },
  mounted() {
    this.tabs.favoriteRooms = false
    if (!this.passesTimeSetting) {
      this.$store.dispatch("passes/getPassesTimeSetting").then((response) => {
        const data = response.data.data
        if (data) {
          this.form.extended_pass_time = data.time_settings.nurse_expire_time
          this.defaultExtendedPassTime = data.time_settings.nurse_expire_time
        }
      })
    } else {
      this.form.extended_pass_time = this.passesTimeSetting.nurse_expire_time
      this.defaultExtendedPassTime = this.passesTimeSetting.nurse_expire_time
    }
    this.getRooms()
    this.initLazyLoading()
  },
  methods: {
    getRooms(page, isLazyLoadingMode, noLoader) {
      this.isLoading = !noLoader
      this.pagination.activePage = page ? page : 1
      this.$store
        .dispatch("rooms/getRooms", {
          sort: this.filterParams.sort_query,
          search_query: this.filterParams.searchQuery,
          page: this.pagination.activePage,
          per_page: this.pagination.per_page.value
        })
        .then((response) => {
          const data = response.data
          if (isLazyLoadingMode) {
            this.$store.commit("rooms/PUSH_ROOMS", data.data)
          } else {
            this.$store.commit("rooms/SET_ROOMS", data.data)
          }
          const meta = data.meta
          if (meta) {
            this.pagination.total = meta.total
            this.pagination.from = meta.from
            this.pagination.to = meta.to
            this.pagination.pages = Math.ceil(meta.total / meta.per_page)
            this.pagination.activePage = Number(this.pagination.activePage)
            this.pagination = JSON.parse(JSON.stringify(this.pagination))
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    initLazyLoading() {
      const body = document.getElementsByClassName("main-scroll-container")[0]
      if (body) {
        body.onscroll = () => {
          if (
            this.isLazyLoadingMode &&
            this.rooms &&
            this.rooms.length &&
            this.pagination.total > this.rooms.length
          ) {
            if (body.offsetHeight + body.scrollTop + 1 >= body.scrollHeight) {
              this.pagination.activePage = this.pagination.activePage + 1
              this.getRooms(this.pagination.activePage, true, false)
            }
          }
        }
      }
    },
    submit(isCreate) {
      if (!isCreate) {
        this.updateRoom(this.editableRoom.id)
      } else {
        this.createRoom()
      }
    },
    updateRoom(roomId) {
      this.isFormLoading = true
      if (this.form.extended_pass_time && this.form.extended_pass_time.HH) {
        this.form.extended_pass_time = Object.values(
          this.form.extended_pass_time
        ).join(":")
      }
      const data = {
        ...this.editableRoom,
        ...this.form
      }
      this.$store
        .dispatch("rooms/updateRoom", {
          roomId,
          data
        })
        .then(() => {
          this.setSuccessResponse("Successfully updated.")
          this.isFormLoading = false
          this.getRooms()
          this.resetExtendedPass()
          this.$store.dispatch("favorites/getFavorites")
          setTimeout(() => {
            this.$store.commit("rooms/SET_EDITABLE_ROOM", null)
            this.resetForm()
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          const response = err.response.data
          this.isFormLoading = false
          this.setErrorResponse(response.message, response.errors)
          if (response.errors["extended_pass_time"]) {
            this.form.extended_pass_time = this.defaultExtendedPassTime
          }
        })
    },
    resetExtendedPass() {
      if (!this.form.is_extended) {
        this.form.extended_pass_time = this.defaultExtendedPassTime
      }
    },
    createRoom() {
      this.resetResponseMessages()
      if (this.isValid) {
        this.isFormLoading = true
        if (this.form.extended_pass_time && this.form.extended_pass_time.HH) {
          this.form.extended_pass_time = Object.values(
            this.form.extended_pass_time
          ).join(":")
        }
        if (!this.form.is_extended) {
          this.form.extended_pass_time = null
        }
        this.$store
          .dispatch("rooms/createRoom", this.form)
          .then(() => {
            this.setSuccessResponse("Successfully created.")
            this.resetForm()
            this.getRooms()
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
          })
          .finally(() => {
            this.isFormLoading = false
          })
      } else {
        this.v$.$touch()
      }
    },
    importRooms() {
      this.resetImportFormMessages()
      this.isImportLoading = true
      const files = this.$refs.file.files
      if (!files.length) {
        this.importReqResponse = {
          type: "danger",
          message: "The csv import field is required.",
          errors: []
        }
        return
      }

      const fileName = files[0].name
      const validExtensions = /(\.csv)$/i
      if (!validExtensions.exec(fileName)) {
        document.getElementById("rooms-import-input").value = ""
        this.importReqResponse = {
          type: "danger",
          message: "Invalid extension",
          errors: []
        }
        this.isImportLoading = false
        return
      }
      const data = new FormData()
      data.append("csv_file", files[0])

      this.$store
        .dispatch("rooms/importRooms", data)
        .then(() => {
          this.importReqResponse = {
            type: "success",
            message: "Rooms imported successfully."
          }
          this.isImportLoading = false
          this.getRooms(1, false, true)
          setTimeout(() => {
            this.resetRooomsImport()
          }, 1500)
        })
        .catch((err) => {
          const response = err.response.data
          this.resetRooomsImport()
          this.importReqResponse = {
            type: "danger",
            message: response.message,
            errors: response.errors
          }
          this.isImportLoading = false
        })
    },
    searchByQuery(value, type) {
      clearInterval(this.searchTimeOut)
      this.searchTimeOut = setTimeout(() => {
        this.handleQuerySearch(value, type)
      }, 500)
    },
    handleQuerySearch(value, type) {
      const query = value.toString()
      if (
        query.replace(/\s/g, "").length > 0 ||
        query.replace(/\s/g, "").length === 0
      ) {
        this.filterParams.searchQuery = ""
        if (type && type === "column") {
          this.columnSearchKeys.globalQuery = ""
          for (const key in this.columnSearchKeys) {
            if (Object.hasOwnProperty.call(this.columnSearchKeys, key)) {
              const columnData = this.columnSearchKeys[key]
              if (columnData.value) {
                columnData.column.forEach((col) => {
                  this.filterParams.searchQuery =
                    this.filterParams.searchQuery +
                    `${col}:"${columnData.value}", `
                })
              }
            }
          }
          this.filterParams.searchQuery = this.filterParams.searchQuery.slice(
            0,
            -2
          )
        } else {
          this.resetSearchQuery()
          this.columnSearchKeys.globalQuery = query
          this.filterParams.searchQuery = query ? '"' + query + '"' : query
        }
        this.getRooms()
      }
    },
    sortByColumn(column) {
      const columnName = this.columnSearchKeys[column.column]
        ? this.columnSearchKeys[column.column].column[0]
        : column.column
      this.filterParams.sort_query = `${columnName}:${
        column.asc ? "asc" : "desc"
      }`
      this.getRooms()
    },
    resetSearchQuery() {
      this.filterParams.searchQuery = ""
      this.columnSearchKeys = {
        globalQuery: "",
        admin_favorite: {
          value: "",
          column: ["admin_favorite"]
        },
        name: {
          value: "",
          column: ["name"]
        },
        comment: {
          value: "",
          column: ["comment_type"]
        },
        trip: {
          value: "",
          column: ["trip_type"]
        },
        extended_pass_time: {
          value: "",
          column: ["extended_pass_time"]
        },
        status: {
          value: "",
          column: ["status"]
        }
      }
    },
    exportRooms() {
      this.isLoading = true
      this.$store
        .dispatch("rooms/exportRooms")
        .then((response) => {
          if (response.data) {
            this.downloadCSVExport(response.data)
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    exportExampleCSV() {
      this.isLoading = true
      this.$store
        .dispatch("rooms/exportExampleCSV")
        .then((response) => {
          if (response.data) {
            this.downloadCSVExport(response.data)
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    downloadCSVExport(data) {
      const csvDataForExport = "data:text/csv;charset=utf-8," + data
      const encodedUri = encodeURI(csvDataForExport)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("target", "_blank")
      link.setAttribute("download", "rooms.csv")
      document.body.appendChild(link)
      link.click()
    },
    setFormByRoomRecord(room) {
      if (room) {
        this.form = {
          name: room.name,
          trip_type: room.trip_type,
          comment_type: room.comment_type,
          status: room.status ? "1" : "0",
          is_extended: !!room.nurses,
          extended_pass_time: room.nurses
            ? room.nurses.end_time
            : this.defaultExtendedPassTime
        }
      }
    },
    editRoom(room) {
      this.resetResponseMessages()
      this.$store.commit("rooms/SET_EDITABLE_ROOM", room)
      this.tabs.addRooms = true
      this.$helpers.scrollToTop()
    },
    cancelEdit() {
      this.$store.commit("rooms/SET_EDITABLE_ROOM", null)
      this.resetForm()
      this.resetResponseMessages()
    },
    setSuccessResponse(message) {
      this.formReqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
      setTimeout(() => {
        this.resetResponseMessages()
      }, 2000)
    },
    setErrorResponse(message, errors) {
      this.formReqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.formReqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    resetImportFormMessages() {
      this.importReqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    checkIfValid(fieldName) {
      const field = this.v$.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || field.$model === "")
    },
    allowAPTRequestToRoom(room) {
      this.$store
        .dispatch("rooms/toggleAPTRequest", {
          id: room.id
        })
        .then(() => {
          this.getRooms(this.pagination.activePage, false, true)
        })
    },
    resetForm() {
      this.form = {
        name: "",
        trip_type: "",
        comment: null,
        status: "1",
        is_extended: false,
        extended_pass_time: this.defaultExtendedPassTime
      }
      this.v$.$reset()
    },
    setPerPage(option) {
      if (option) {
        this.isLazyLoadingMode = option.label === "All entries"
        this.pagination.per_page = option
        this.getRooms()
      }
    },
    setActivePage(page) {
      this.pagination.activePage = page
      this.getRooms(this.pagination.activePage)
      this.$helpers.scrollToTop()
    },
    showImportModal() {
      this.showReadMore = true
    },
    closeModal() {
      this.showReadMore = false
    },
    toggleTab(tab) {
      this.tabs[tab] = !this.tabs[tab]
    },
    clearExtendedPass() {
      this.resetResponseMessages()
      this.form.extended_pass_time = this.defaultExtendedPassTime
    },
    matchAPTRequests(value) {
      const options = [
        {
          value: false,
          label: "No"
        },
        {
          value: true,
          label: "Yes"
        }
      ]
      const aptRequest = options.filter((option) =>
        option.label.toLowerCase().includes(value.toLowerCase())
      )[0].value
      this.columnSearchKeys.enable_appointment_passes.value = aptRequest
      this.searchByQuery(aptRequest, "column")
    },
    matchStatus(value) {
      const options = {
        active: 1,
        inactive: 0
      }
      // eslint-disable-next-line no-prototype-builtins
      if (options.hasOwnProperty(value)) {
        this.searchByQuery(options[value], "column")
      } else {
        this.columnSearchKeys.status.value = ""
      }
    },
    addAdminFav(item) {
      if (this.user.role.name == "admin" && !this.isLoading) {
        this.isLoading = true
        this.$store.dispatch("favorites/toggleFavorite", item).then(() => {
          this.getRooms()
        })
      }
    },
    resetRooomsImport() {
      this.importReqResponse = {
        type: "",
        message: "",
        errors: {}
      }
      document.getElementById("rooms-import-input").value = ""
    }
  }
}
</script>
<style lang="scss">
.sort-arrows {
  top: calc(50% - 10px);
  right: 10px;
}

.flaticon-double-chevron.up {
  transform: rotate(-90deg);
}

.flaticon-double-chevron.down {
  transform: rotate(90deg);
}
</style>
